import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import templateServices from '../../services/TemplateServices';
import { autorun } from 'mobx';
import Utils from '../../common/Utils';
import { MOBILE_VIEWS } from '../../common/Foundation';


@inject('LayoutTemplateStore', 'AccountStore', 'MyBetsStore')
@observer
class FooterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comps: null,
      currentViewContainer: ""
    }
    this.LayoutTemplateStore = this.props.LayoutTemplateStore;
    const { auth,type } = this.props.AccountStore.user;
  }

  componentDidMount() {
      this.autorun = autorun(() => {
          let currentViewContainer = this.LayoutTemplateStore.currentViewContainer;
          if (this.state.currentViewContainer !== currentViewContainer) {
            let dataComps = [];
            if (this.LayoutTemplateStore.templateData.headerContainer != null) {
              const componentsByView = this.LayoutTemplateStore.templateData.footerContainer[currentViewContainer];
              const { euroView, formal } = this.LayoutTemplateStore.templateData.footerContainer;
              if (componentsByView != null && componentsByView.length > 0) {
                dataComps = currentViewContainer === MOBILE_VIEWS.EURO 
                  ? [...euroView, ...formal]
                  : componentsByView || [];
              } else {
                dataComps = this.LayoutTemplateStore.templateData.footerContainer.formal || []
              }

            }
            this.setState({
                comps: templateServices.listComponentsByData(dataComps) || ( <div> </div>),
                  currentViewContainer: currentViewContainer
                });
            }

          });
      }

  componentWillUnmount() {
    this.autorun();
  }

  render() {    
    const { auth,type } = this.props.AccountStore.user;
    const {isNGC} = this.props.AccountStore;
    const myBetFooterClass = 
      (this.LayoutTemplateStore.currentViewContainer === 'euroView' || Utils.isPA()) && 
      this.props.MyBetsStore.enabledFilterOptions 
        ? 'with-my-bet-footer' 
        : ''

    if(isNGC || !this.LayoutTemplateStore.isShowFooter) {
      return null;
    }

    return (
        <div id={'footer'} className={`${auth ? "auth" : "noauth"} ${type} ${myBetFooterClass} footer_container`}>
          {this.state.comps}  
        </div>
    );
  }
  
}

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/app/components/FooterComponent/index.js